function onPageResize () {
  var body = document.body

  function scrolled () {
    null !== body && (window.scrollY >= 20 ? body.classList.add('scrolled') : body.classList.remove('scrolled'))
  }

  window.addEventListener('scroll', scrolled)
  scrolled()

}

onPageResize()
